var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModeSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39cm",
    height: "29cm",
    viewBox: "698 -622 764 564",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 700,
    y: -620,
    width: 760,
    height: 560
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 700,
    y: -620,
    width: 760,
    height: 560
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1100,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1100,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1140,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1140,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1180,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1180,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1220,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1220,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1260,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1260,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1300,
    y: -480,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1300,
    y: -480,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1040,
    y: -500
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -500
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1080,
    y: -500
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -500
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1120,
    y: -500
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 1120,
    y: -500
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1160,
    y: -500
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1160,
    y: -500
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1200,
    y: -500
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 1200,
    y: -500
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1240,
    y: -500
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1240,
    y: -500
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: -500
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: -500
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1320,
    y: -500
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1320,
    y: -500
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1360,
    y: -450.225
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1360,
    y: -450.225
  }, "TGS"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1060,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1060,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1100,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1100,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1140,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1140,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1180,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1180,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1220,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1220,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1260,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1260,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1300,
    y: -140,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1300,
    y: -140,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1040,
    y: -160
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -160
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1080,
    y: -160
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -160
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1120,
    y: -160
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1120,
    y: -160
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1160,
    y: -160
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1160,
    y: -160
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1200,
    y: -160
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1200,
    y: -160
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1240,
    y: -160
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1240,
    y: -160
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1280,
    y: -160
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1280,
    y: -160
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1320,
    y: -160
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1320,
    y: -160
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1360,
    y: -110.225
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1360,
    y: -110.225
  }, "PAT"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 740,
    y: -320,
    width: 240,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 740,
    y: -320,
    width: 240,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 980,
    y: -320,
    width: 40,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 980,
    y: -320,
    width: 40,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1020,
    y: -320,
    width: 40,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1020,
    y: -320,
    width: 40,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1060,
    y: -320,
    width: 40,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1060,
    y: -320,
    width: 40,
    height: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 980,
    y: -360,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 980,
    y: -360,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1020,
    y: -360,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1020,
    y: -360,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1060,
    y: -360,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1060,
    y: -360,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 740,
    y: -360,
    width: 240,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 740,
    y: -360,
    width: 240,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: 700
    },
    x: 860,
    y: -334.125
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 860,
    y: -334.125
  }, "MODE"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 760,
    y: -296.458
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 760,
    y: -296.458
  }, "40 Caract\xE8res - Long")), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 760,
    y: -275.292
  }, "40 Caract\xE8res - Variable")), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 760,
    y: -254.125
  }, "40 Caract\xE8res - Court")), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 760,
    y: -232.958
  }, "80 Caract\xE8res - Long")), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 760,
    y: -211.792
  }, "80 Caract\xE8res - Court"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: 700
    },
    x: 1000,
    y: -334.125
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -334.125
  }, "PAT"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: 700
    },
    x: 1040,
    y: -334.125
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -334.125
  }, "TGS"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: 700
    },
    x: 1080,
    y: -334.125
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -334.125
  }, "TGS"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1000,
    y: -296.458
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -296.458
  }, "0")), _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -275.292
  }, "0")), _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -254.125
  }, "1")), _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -232.958
  }, "0")), _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 1000,
    y: -211.792
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1040,
    y: -296.458
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -296.458
  }, "0")), _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -275.292
  }, "0")), _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -254.125
  }, "0")), _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -232.958
  }, "1")), _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: -211.792
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1080,
    y: -296.458
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -296.458
  }, "0")), _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -275.292
  }, "1")), _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -254.125
  }, "0")), _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -232.958
  }, "1")), _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: -211.792
  }, "0"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1000,
    y1: -120,
    x2: 1000,
    y2: -188
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1005,-188 1000,-198 995,-188 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1005,-188 1000,-198 995,-188 "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1040,
    y1: -120,
    x2: 1000,
    y2: -120
  }), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1060,
    y: -560
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1060,
    y: -560
  }, "Registres de s\xE9lection du mode"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1040,
    y1: -460,
    x2: 1040,
    y2: -372
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1035,-372 1040,-362 1045,-372 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1035,-372 1040,-362 1045,-372 "
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -140,
    x2: 1060,
    y2: -140
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -100,
    x2: 1060,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -140,
    x2: 1020,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1060,
    y1: -140,
    x2: 1060,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -480,
    x2: 1060,
    y2: -480
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -440,
    x2: 1060,
    y2: -440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1020,
    y1: -480,
    x2: 1020,
    y2: -440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1060,
    y1: -480,
    x2: 1060,
    y2: -440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1060,
    y1: -480,
    x2: 1100,
    y2: -480
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1060,
    y1: -440,
    x2: 1100,
    y2: -440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1060,
    y1: -480,
    x2: 1060,
    y2: -440
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1100,
    y1: -480,
    x2: 1100,
    y2: -440
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 1080,
    y1: -460,
    x2: 1080,
    y2: -372
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "1075,-372 1080,-362 1085,-372 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "1075,-372 1080,-362 1085,-372 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeSelect);
export default __webpack_public_path__ + "static/media/ModeSelect.18a87c19e303a737fae387f6d5c075b3.svg";
export { ForwardRef as ReactComponent };